"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.74,1.57v5h-5v-5h5M8.32,0H.2V8.11H8.32Z",
    fill: "#014864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.34,1.57v5h-5v-5h5M21.92,0H13.81V8.11h8.11Z",
    fill: "#014864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.74,15.16v5h-5v-5h5m1.58-1.59H.2v8.11H8.32Z",
    fill: "#014864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.15",
    y: "-0.02",
    width: "1.89",
    height: "7.28",
    fill: "#014864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.11",
    y: "10.9",
    width: "14.84",
    height: "1.83",
    fill: "#014864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.2",
    y: "10.9",
    width: "3.86",
    height: "1.83",
    fill: "#014864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.63,15.44h-3v1.83h2.18A7.4,7.4,0,0,1,13.63,15.44Z",
    fill: "#014864"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "18.72",
    cy: "18.85",
    r: "5.15",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.2,21.71a.25.25,0,0,1-.22-.37L20,16a.25.25,0,0,1,.34-.09.25.25,0,0,1,.09.34l-3,5.32A.25.25,0,0,1,17.2,21.71Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.24,21.7a1.2,1.2,0,0,1-1-1.33,1.2,1.2,0,0,1,1-1.33,1.21,1.21,0,0,1,1,1.33A1.21,1.21,0,0,1,20.24,21.7Zm0-2.15c-.3,0-.55.38-.55.83s.25.83.55.83.55-.38.55-.83S20.54,19.55,20.24,19.55Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.2,18.55a1.21,1.21,0,0,1-1-1.33,1.21,1.21,0,0,1,1-1.33,1.21,1.21,0,0,1,1,1.33A1.21,1.21,0,0,1,17.2,18.55Zm0-2.15c-.3,0-.55.38-.55.83s.25.83.55.83.55-.38.55-.83S17.49,16.39,17.2,16.39Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;